module.exports = __webpack_public_path__ + "src/modules/home/training/images/1703.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/training/images/1703.png
// module id = 786
// module chunks = 0